export const sampleCartItems = [
  {
    id: '1',
    name: 'Premium T-Shirt',
    variant: 'Schwarz / XL',
    price: 24.99,
    quantity: 2,
    image: 'https://picsum.photos/200?1',
    options: [
      { name: 'Farbe', value: 'Schwarz' },
      { name: 'Größe', value: 'XL' }
    ]
  },
  {
    id: '2',
    name: 'Slim Fit Jeans',
    variant: 'Blau / 32/34',
    price: 59.95,
    quantity: 1,
    image: 'https://picsum.photos/200?2',
    options: [
      { name: 'Farbe', value: 'Dunkelblau' },
      { name: 'Größe', value: '32/34' }
    ]
  },
  {
    id: '3',
    name: 'Sneaker Classic',
    variant: 'Weiß / 44',
    price: 89.95,
    quantity: 1,
    image: 'https://picsum.photos/200?3',
    options: [
      { name: 'Farbe', value: 'Weiß' },
      { name: 'Größe', value: '44' }
    ]
  }
];
